import { z } from 'zod';

export const contactSchema = z.object({
  name: z.string().trim().min(1, 'Required.').max(200, 'Too long.'),
  email: z
    .string()
    .trim()
    .min(1, 'Required.')
    .max(200, 'Too long.')
    .regex(/^\S+@\S+\.\S+$/, "Doesn't look like an email."),
  company: z.string().trim().min(1, 'Required.').max(200, 'Too long.'),
  role: z.string().trim().min(1, 'Required.').max(200, 'Too long.'),
  stack: z.string().trim().min(1, 'Required.').max(5000, 'Too long.'),
  surfaces: z.string().trim().min(1, 'Required.').max(5000, 'Too long.'),
  message: z.string().max(5000, 'Too long.').optional().default(''),
});

export type ContactInput = z.infer<typeof contactSchema>;
